import React from "react"; 
import Select from "react-select";
 
 const CustomSelectComponent = ({ value, options, onSelect , defaultInputValue, placeholder, styles, disabled}) => {
    return <Select value={value} options={options} onChange={onSelect} defaultInputValue={defaultInputValue} placeholder={placeholder} styles={styles} isDisabled={disabled}/>;
  };

  export default CustomSelectComponent;